/** The own fields of an untrusted value, empty when it is not an object. */
export function objectFields(value: unknown): Map<string, unknown> {
  if (value == null || typeof value !== 'object') {
    return new Map();
  }
  return new Map(Object.entries(value));
}

/** One field of an untrusted value, when it holds a string. */
export function stringField(fields: Map<string, unknown>, key: string): string | undefined {
  const value = fields.get(key);
  return typeof value === 'string' ? value : undefined;
}
